import React from 'react'
import PropTypes  from 'prop-types'
export default function Navbar(props) {
    return (
        <div className='container-fluid'>
<nav className={`navbar fixed-top navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
  <div className="container">
    <a className="navbar-brand" href="#">Nosherwan</a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>

    <div className="collapse navbar-collapse" id="navbarNav">
      <ul className="navbar-nav ms-auto">
        <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="#">Home</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="#scroll2">About</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="#scroll3">Projects</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="#scroll4">Contect</a>
        </li>
      </ul>
      <div className={`form-check form-switch text-${props.mode==='light'?'dark':'light'}`}>
        <input className="form-check-input" type="checkbox" onClick={props.toggleMode} id="flexSwitchCheckDefault"/>
        <label className="form-check-label" htmlFor="flexSwitchCheckDefault">{props.mode==='light'?"Light Mode On":"Dark Mode On"}</label>
      </div>
    </div>

  </div>
</nav>
</div>
    )
}
